import { Uni } from '@vendia/management-api-types'
import { Navigate } from 'react-router-dom'
import { useRecoilValue } from 'recoil'
import PageLoader from 'src/components/loaders/page-loader'
import { hasReadAccess, useNodeAccessLevels } from 'src/utils/auth/node-access'
import { isGettingStartedCompleted } from 'src/utils/getting-started-completed'
import { useGetUni } from 'src/utils/hooks/use-get-uni'
import { useSafeParams } from 'src/utils/security/use-safe-params'
import { userState } from 'src/utils/state'

export const UniRedirect = () => {
  const { id: uniName } = useSafeParams()
  const { email } = useRecoilValue<any>(userState)
  const getUniQuery = useGetUni()
  const uni = getUniQuery?.data?.getUni as Uni | undefined
  const nodes = uni?.nodes || []
  const nodeZeroName = nodes?.[0]?.name

  // Try to route the user to the best node for them
  let nodeName = nodeZeroName
  const nodeAccessMap = useNodeAccessLevels(uni)
  const nodesUserOwns = nodes.filter((node) => node.userId === email)
  const nodesWithReadAccess = nodes.filter((node) => (nodeAccessMap ? hasReadAccess(nodeAccessMap, node) : false))
  if (nodesUserOwns.length > 0) {
    nodeName = nodesUserOwns[0].name
  } else if (nodesWithReadAccess.length > 0) {
    nodeName = nodesWithReadAccess[0].name
  }

  // Note: isPending (not isLoading) is used here because TanStack Query v5 considers disabled queries
  // (enabled: false) as not loading, even though their data isn't available yet. useGetUni is gated
  // on selectedRoleName and api being ready, so it starts in a disabled/pending state. isPending
  // correctly captures "data isn't ready yet" in both the disabled and fetching cases.
  const isLoading = getUniQuery.isPending

  if (isLoading) {
    return (
      <div className='grid place-items-center'>
        <PageLoader />
      </div>
    )
  }

  const landingPage = isGettingStartedCompleted(uniName) ? 'mcp-dashboard' : 'getting-started'
  return <Navigate to={`/uni/${uniName}/${nodeName}/${landingPage}`} />
}
